import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDoor"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V20.5H22V22H2V20.5H4V2ZM7 11.5H9.5V13H7V11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDoor;
